import { compose } from "redux";
import React, { PureComponent } from "react";

import { WorkDayMapper } from "features/planner/planner.mappers";
import WorkScheduleReportWorkDayWeek from "features/planner/report/workSchedule/components/WorkScheduleReportWorkDayWeek";
import WorkScheduleReportWeekPreview from "features/planner/report/workSchedule/components/WorkScheduleReportWeekPreview";
import WorkScheduleYearReportWorkWeekPreviewDay from "features/planner/report/workSchedule/components/year/WorkScheduleYearReportWorkWeekPreviewDay";

class WorkScheduleYearReportWorkWeek extends PureComponent {
  renderPreviewDay = (day, index) => {
    const { workWeek } = this.props;

    const workDay = workWeek
      .get("scheduleDays")
      .find(x => x.get("date").isSame(day, "day"));

    return (
      <WorkScheduleYearReportWorkWeekPreviewDay
        key={index}
        date={day}
        workDay={workDay}
      />
    );
  };

  render() {
    const { workWeek } = this.props;

    const status = workWeek.get("status");

    return (
      <WorkScheduleReportWorkDayWeek
        status={status}
        flexDayCount={workWeek.get("flexDayCount")}
        title={
          <WorkScheduleReportWeekPreview
            date={workWeek.get("weekStartDate")}
            renderPreviewDay={this.renderPreviewDay}
          />
        }
      />
    );
  }
}

WorkScheduleYearReportWorkWeek.defaultProps = {
  workWeek: WorkDayMapper.initial(),
};

export default compose()(WorkScheduleYearReportWorkWeek);
